
const lazyLoadScript = require('lazyload-script');
const { serviceName } = require('../analytics/app-events');

const scriptURL = 'https://cdn.trackjs.com/agent/v3/latest/t.js'; // global
// const scriptURL = '/mod/trackjs/index.umd.js'; // local
// const errorURL = '/p/trackjs';

/** @type {[AppEventKey, string | ((evt: CustomEvent) => void)][]} */
const handlers = [
  ['app:start', 'App started'],
  ['app:close', 'App closed'],
  ['language:change', e => `Language changed to '${e.detail}'`],
  ['search', e => `Search for '${e.detail.term}'`],
  ['service:closest:show', e => `Show closest service '${serviceName(e)}'`],
  ['service:highlight', e => `Highlight service '${serviceName(e)}'`],
  ['service:route', e => `Show route to service '${serviceName(e)}'`],
  ['session:start', 'Session started'],
  ['session:end', 'Session ended'],
  ['view:change', e => `Go to '${e.detail}'`],
  ['ui:transform', e => `Transform UI '${e.detail}'`]
];

// addEventHandlers :: Events -> TrackJS -> void
const addEventHandlers = events => TrackJS => handlers.forEach(
  ([type, handler]) => {
    const getMessage =
      typeof handler == 'string' ? () => handler :
        typeof handler == 'function' ? handler :
          () => `Unknown event handler for '${type}'`;

    events.addEventListener(type, event => TrackJS.console.log(getMessage(event)));
  }
);

module.exports = {

  /*
   *  Loads TrackJS and installs it if a configuration is available. In case
   *  loading fails we skip error tracking. Anyway, tracking errors wouldn't
   *  make much point if there's network problems.
   */
  // init :: (Events, ImdSettings) -> Promise
  init (events, imdSettings) {
    const { version } = imdSettings;
    const { trackjs } = imdSettings.integration;
    if (trackjs && trackjs.token) {
      return lazyLoadScript(scriptURL, {async: true})
        .then(() => {
          const successful = window.TrackJS.install(
            Object.assign(
              { version: `v${version}` },
              trackjs
            )
          );
          if (successful) return window.TrackJS;
          throw new Error('Failed');
        })
        .then(addEventHandlers(events))
        .catch(_ => console.error('Loading TrackJS failed'));
    }
    else {
      return Promise.reject(`No TrackJS 'token' property`);
    }
  }
};
